import { urlFor } from "../sanity/lib/image";

const CodeBlock = ({ value }) => {
	// const sanitizedCode = DOMPurify.sanitize(value.code);
	return (
		<pre>
			<code dangerouslySetInnerHTML={{ __html: value.code }}></code>
		</pre>
	);
};

export const portableTextComponents = {
	types: {
		code: CodeBlock,
		image: ({ value }) => {
			const imageUrl = value?.asset?._ref
				? urlFor(value.asset).url()
				: null;

			const maxWidth = value?.maxWidth || '100%';

			return imageUrl ? (
				<img
					src={imageUrl}
					alt={value.alt || 'Block image'}
					style={{ maxWidth }}
				/>
			) : null;
		},
	},
	marks: {
		link: ({ children, value }) => {
			const linkHref = value.href !== undefined ? value.href : '';
			const isExternal = linkHref.startsWith('http') && !linkHref.includes('plpcsanjose.com');

			return (
				<a
					href={linkHref}
					target={isExternal ? '_blank' : '_self'}
					rel={isExternal ? 'noopener noreferrer' : undefined}
					className={isExternal ? 'external-link' : 'internal-link'}
				>
					{children}
				</a>
			);
		},
		color: ({ children, value }) => {
			return (
				<span
					style={{ color: `rgba(${value.rgb.r},${value.rgb.g},${value.rgb.b},${value.rgb.a})` }}
				>
					{children}
				</span>
			);
		},
	},
};
